export default "__VITE_ASSET__BrwZDCnE__"